module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"no_media":"첨부된 포토/동영상이 없는 리뷰입니다.","filtered_review_mismatch":"선택하신 리뷰는 현재 필터 조건에 맞지 않습니다. 조건에 맞는 첫 번째 리뷰를 표시합니다.","filtered_review_none":"현재 필터 조건에 맞는 리뷰가 없습니다. 필터를 해제한 후 다시 확인해 주세요."}}')
  delete Component.options._Ctor
}
